import {icons} from "@/ui/icons"

export const superSubmenuOptions = <const>[
  // {name: "Plan details", url: "planDetails", icon: icons.imNotepad},
  {name: "SuperScore", url: "superScore", icon: icons.siStar},
  {
    name: "Nominated beneficiary",
    url: "nominatedBeneficiary",
    icon: icons.imMaleFemale,
  },
  {
    name: "Account balance",
    url: "accountBalance",
    icon: icons.imBasketCoins,
  },
  {
    name: "Life insurance",
    url: "lifeInsurance",
    icon: icons.imLifeSafer,
  },
  {
    name: "Investment approach",
    url: "investmentApproach",
    icon: icons.imPieChart3,
  },
  {
    name: "Retirement adequacy",
    url: "retirementAdequacy",
    icon: icons.imSun,
  },
  {
    name: "Analytics",
    url: "analytics",
    icon: icons.imBarChart4,
  },
  {
    name: "Members",
    url: "members",
    icon: icons.imBusinessManWoman,
  },
]
